<template>
    <Modal :id="'Enviar_Email'" :size="''" :open="show" :FooterDefault="false">
        <template v-slot:header>
            <h6 class="modal-title">Enviar e-mail</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times btn-close-style"></i></button>
        </template>
        <template v-slot:body>
            <div class="row" style="overflow-y: auto; overflow-x: hidden; max-height: calc(100vh - 9rem); min-height: calc(100vh - 9rem);">
                <div class="col">
                    <div class="col table-dados" v-if="idModulo != 0 && idInstituicao != 0">
                        <DataTable :url_ajax="getUrlHistoricoEmails()" :ajax_set_result="setHistorico"
                                   @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro" method="GET"
                                   :qtd_registros_por_pagina="8" :is_table="true" :footer_fixed="true" :headers="headersHistoricoEmails"
                                   :pBtnsSlot="true" :request_api="'comercial'">
                            <template v-slot:BtnSlot="item">
                                <div class="campo">
                                    <div class="d-flex">
                                        <div class="col">
                                            <h3 class="col">{{ item.row.nmModelo }}</h3>
                                        </div>
                                        <div class="col">
                                            <span class="data col">{{ item.row.dtInclusaoString }}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="col" style="text-align: left;">
                                            <span class="data col">{{ item.row.dsLoginEnvio }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </DataTable>
                    </div>
                </div>
                <div class="col">
                    <div class="col mb-3">
                        <label class="form-label">Selecione o Modelo de E-mail</label>
                        <vue-select :options="Modelos_Emails" v-model="modeloEmailSelected" :label-by="(e) => (e.nmModelo)"
                                    placeholder="Selecione..." search-placeholder="Pesquise" searchable
                                    close-on-select clear-on-select :min="1" class="form-control shadow-v2"
                                    :class="{ filled: Object.keys(modeloEmailSelected).length !== 0 }">
                        </vue-select>
                    </div>
                    <!--<ckeditor :editor="editor" v-model="htmDisparo">
                    </ckeditor>-->
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2"
                        data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="submit" class="btn btn-red-v2" form="form" v-on:click="enviar">Enviar</button>
            </div>
        </template>
    </Modal>
</template>

<script>

    import $ from 'jquery'
    import axios from 'axios';
    import Modal from '@/components/App//Modal.vue';
    import DataTable from '@/components/App//Datatable.vue'
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    /*import ClassicEditor from '@ckeditor/ckeditor5-build-classic';*/
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        name: 'EnviaEmail',
        components: {
            Modal,
            'vue-select': VueNextSelect,
            DataTable,
            /*ckeditor: CKEditor.component*/
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idPessoa: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            nmPessoa: {
                type: String,
                default: ''
            },
            nmEmpresa: {
                type: String,
                default: ''
            },
            nrTelefone: {
                type: String,
                default: ''
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                pessoa: {},
                ultimoEmail: '',
                headersHistoricoEmails: [
                    { class: '', name: 'btns', text: 'Histórico de e-mails', actions: true, }
                ],

                filtro: [
                    { active: true },
                ],
                LicacaoCrud: {
                    dsAnotacao: '',
                    nrTelefone: ''
                },
                /*editor: ClassicEditor,*/

                htmDisparo: '',

                telefonePersonalizado: 0,

                refresh_grid: false,

                Modelos_Emails: [],
                modeloEmailSelected: {},
                enviarCrud: {
                    idModeloEmailEnvio: 0,
                    idModeloEmail: 0,
                    idPessoa: 0,
                    idInstituicao: 0,
                    idModulo: 0,
                    idOcorrencia: 0,
                    htmEnviado: ''
                },
                ocorrencia: {}
            }
        },
        computed: {},
        methods: {
            gridRefreshed(data_ajax) {
                let $this = this;
                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;
                $this.refresh_grid = true;
            },
            getModeloEmail() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmail/Get?idModulo=' + $this.idModulo + '&idOcorrencia=' + $this.idOcorrencia, {
                        headers: $this.$api.getTokenComercial()
                    }).then(response => {
                        $this.Modelos_Emails = response.data.data.rows;
                    })
                })
            },
            formatNumber(value) {
                return value.toString().padStart(2, '0');
            },
            getUrlHistoricoEmails() {
                let $this = this;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmailEnvio/GetPessoaHistoricoContatoTicket?' + 'idPessoa=' + $this.idPessoa + '&idInstituicao=' + $this.idInstituicao + '&idOcorrencia=' + $this.idOcorrencia;
            },
            getPessoa() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Pessoa/GetId?idPessoa=' + $this.idPessoa + '&idInstituicao=' + $this.idInstituicao, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.pessoa = response.data.data;
                });
            },
            enviar() {
                let $this = this;

                $this.enviarCrud.idModeloEmailEnvio = 0;
                $this.enviarCrud.idModeloEmail = $this.modeloEmailSelected.idModeloEmail;
                $this.enviarCrud.idPessoa = $this.idPessoa;
                $this.enviarCrud.idInstituicao = $this.idInstituicao;
                $this.enviarCrud.idModulo = $this.idModulo
                $this.enviarCrud.idOcorrencia = $this.idOcorrencia;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmailEnvio/PostModeloEmailTicket', $this.enviarCrud, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        var myModalEl = document.getElementById('Enviar_Email');
                        var ModalEnviarEmail = window.bootstrap.Modal.getInstance(myModalEl);
                        ModalEnviarEmail.hide();
                        $this.reloadGrid();
                        $this.$emit('reloadGrid');
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            setHistorico(result) {
                result.forEach((value, index) => {
                    if (value.flProcessada) {
                        value.flProcessada = '<i class="fas fa-check icon-grid-lista-check" style="color: #34A853"></i>';
                    } else {
                        value.flProcessada = '<i class="fas fa-times icon-grid-lista-uncheck" style="color: #9F3029"></i>';
                    }
                })
                return result;
            }

        },
        mounted() {
            this.getPessoa();
            this.refresh_grid = true;
            this.getModeloEmail();

        },
        watch: {
            modeloEmailSelected(newValue, oldValue) {
                let $this = this;
                $this.htmDisparo = newValue.htmModelo;
            }
        }
    }

</script>

<style scoped>

    .fundo-dados {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    .modal-body {
        min-height: 150px !important;
    }

    .fundo-panel {
        max-height: 77vh;
        overflow: auto;
    }

    h3 {
        color: #434343;
        font-size: 12px;
        font-family: Inter;
        font-weight: 700;
        text-align: left
    }

    h4 {
        color: #9F3029;
        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        margin-left: 10px;
        padding: 16px 0;
    }

    .campo {
        padding: 4px;
    }

    .tem_registro {
        color: #ACACAC;
        font-size: 14px;
        font-family: Inter;
        line-height: 140.625%;
        margin: 0 8px;
        border-radius: 5px;
        background: #FFF;
        height: 80px;
        padding: 8px;
        min-height: calc(100vh - 330px);
    }

    .card_registro {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
    }

    .solid_bar {
        width: 4px;
        margin-right: 8px;
        border-radius: 2px;
        background: #9F3029;
    }

    .card_contato {
        border-radius: 5px;
        background: #FFF;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
        padding: 8px;
    }

    strong {
        color: #434343;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        height: 26px;
    }

    .card_text {
        color: #434343;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140.625%; /* 16.875px */
    }

    .btn-editar-lista {
        border-radius: 5px;
        border: 1px solid #9F3029;
        background: #FFF;
        color: #9F3029;
        font-family: Inter;
        font-style: normal;
        font-weight: 700;
        line-height: 140.625%;
        padding: 8px 16px;
    }
</style>